var CustomScreenModel = function( xmlString ){
	var i = 0,
		self;

	AbstractDataModel.apply( self, arguments );

	self = this;

	AbstractDataModel.prototype.loadData.call( self, xmlString );

	self.fields						= ko.observableArray( [] );
	self.name						= self.json.name;
	self.transactionTypeId			= self.json.transactionTypeId || null;
	self.requiredBeforeAppointment	= self.json.requiredBeforeAppointmentSelection || false;


	/**
	* A method to convert an XML node of a field into a
	* javascript object with properties
	*
	* @method createField
	* @param {Object} obj XML node object
	* @return {Object} Returns an object with properties
	*/
	self.createField = function ( obj ) {
		var i = 0,
			fieldObj = {};

		fieldObj.id					= obj.id;
		fieldObj.type				= obj.type.toLowerCase();
		fieldObj.name				= obj.name.replace(/[^a-zA-Z0-9]/g, '_');
		fieldObj.length				= ( obj.length ) ? obj.length : 999;
		fieldObj.inputMask			= null;
		fieldObj.enableWhitelist	= ( obj.enableWhitelist && obj.enableWhitelist == true );
		fieldObj.mustMatchExisting	= ( obj.mustMatchExisting && obj.mustMatchExisting == true );
		fieldObj.options			= ko.observableArray( [] );
		fieldObj.required			= ( obj.required && obj.required == true );

		fieldObj.inputMask			= fieldObj.type === 'number' ? '0#' : null;

		if (fieldObj.type === 'button' || 
			fieldObj.type == 'radiobutton' ||
			fieldObj.type == 'autocomplete' ) {
			fieldObj.type = 'select';
		}

		if ( fieldObj.type == 'select' ) {
			for( i = 0; i < obj.option.length; i++ ) {
				fieldObj.options.push( obj.option[i] );
			}
		}

		fieldObj.label = ko.computed( function () {
			var langLabel = qcal.messagesWS.get('customField.'+ obj.name +'.label');

			if (langLabel != '') {
				return langLabel;
			}

			return obj.label;
		});

		// Create a matching observable on the view model
		//
		//kiosk.customScreenFieldObservable(fieldObj.name, null);

		return fieldObj;
	};


	/**
	* Determines if a screen's field consist of only checkboxes
	*
	* @method onlyCheckboxes
	* @return {Boolean}
	*/
	self.onlyCheckboxes = ko.computed( function () {
		var bOnlyChecks = true;

		self.fields().forEach( function ( field ) {
			if ( field.type != 'checkbox' ) {
				bOnlyChecks = false;
			}
		});

		return bOnlyChecks;
  });


	/**
	* Determines if a screen's field consist of only buttons
	*
	* @method onlyButtons
	* @return {Boolean}
	*/
  self.onlyButtons = ko.computed( function () {
    var fields = self.fields();
    var buttons = fields.filter( function ( field ) {
      return field.type == 'button';
    });

    return buttons.length == fields.length;
  });


	/**
	* This method looks through the CustomScreenModel's fields collection
	* and tries to match the fieldName passed with a name property in each
	* field. If found, it will return the corresponding id value, or null
	* if an id was not found
	*
	* @method getFieldIdByName
	* @param {String} sFieldName
	* @param {Number|Null} Id of the field
	*/
	self.getFieldIdByName = function ( sFieldName ) {
		var i = 0,
			id = null;

		sFieldName = sFieldName.replace('customscreenfield_', '');

		for ( i=0; i < self.fields().length; i++ ) {
			if ( self.fields()[i].name == sFieldName ) {
				id = self.fields()[i].id;
				break;
			}
		}

		return id;
	};


	/**
	* Returns the title text of the custom screen
	*
	* @method title
	* @return {String}
	*/
	self.title = ko.computed( function () {
		var langTitle = qcal.messagesWS.get('customScreen.'+ self.name +'.title');

		return ( langTitle != '' ) ? langTitle : self.json.title;
	});


	if ( self.json.field.constructor == Object ) {
		self.fields.push( self.createField( self.json.field ) );
	}
	else if ( self.json.field.constructor === Array ) {
		for ( i = 0; i < self.json.field.length; i++ ) {
			self.fields.push( self.createField( self.json.field[i] ) );
		}
	}

	self.mustValidateCustomProps = ko.computed( function () {
		var i = 0,
			field = null;

		for ( i = 0; i < self.fields().length; i++ ) {
			field = self.fields()[i];

			if ( field.mustMatchExisting == true || field.enableWhitelist == true) {
				return true;
			}
		}

		return false;
	});

	return self;
};

CustomScreenModel.prototype = AbstractDataModel.prototype;
CustomScreenModel.prototype.constructor = CustomScreenModel;
